import { WhereClauseCondition } from "../ars_ldm";

/**
 * Type guard to check if a value is a WhereClauseCondition.
 *
 * @param value - The value to check.
 * @returns True if the value is a WhereClauseCondition, false otherwise.
 */
export const isWhereClauseCondition = (value: unknown): value is WhereClauseCondition => {
  if (typeof value !== "object" || value === null) {
    return false;
  }
  const chkObj = value as WhereClauseCondition;
  // Check strings
  if (!["undefined", "string"].includes(typeof chkObj.dataset)) {
    return false;
  }
  if (!["undefined", "string"].includes(typeof chkObj.variable)) {
    return false;
  }
  if (!["undefined", "string"].includes(typeof chkObj.comparator)) {
    return false;
  }
  // Check value array
  if (
    chkObj.value !== undefined &&
    (!Array.isArray(chkObj.value) || !chkObj.value.every((v) => typeof v === "string"))
  ) {
    return false;
  }
  // Everything is good
  return true;
};
